import { render, staticRenderFns } from "./D2CDialogContentPremiumBreakdown.vue?vue&type=template&id=4640c05a&scoped=true&"
import script from "./D2CDialogContentPremiumBreakdown.vue?vue&type=script&lang=js&"
export * from "./D2CDialogContentPremiumBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./D2CDialogContentPremiumBreakdown.vue?vue&type=style&index=0&id=4640c05a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4640c05a",
  null
  
)

export default component.exports